export enum ReasonForConsultEnum {
  Diagnosis = 'Diagnosis',
  Management = 'Management',
  DiagnosisAndManagement = 'DiagnosisAndManagement',
}
